import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class Rc1EstimateStore {
  /**
   * Whole dollars a year. Undefined when the save returned none (the address didn't match a county we serve, the
   * email already has an account, Kindex has no estimate or isn't confident Kin is competitive, or couldn't be
   * reached): /enrolled then shows the offer without a figure.
   */
  readonly annualPremium = signal<number | undefined>(undefined);

  reset(): void {
    this.annualPremium.set(undefined);
  }
}
